import { TextField } from '@atgfr8/atg-ui-tailwind';
import { reasonsToHoldPayment } from '@common/commonLists';
import { Button, SelectInput } from '@components';
import { createForm } from '@felte/solid';
import { validator } from '@felte/validator-yup';
import { closeModal } from '@store/modals';
import { updateLoadPropertyAtIndex } from '@store/orders';
import { formatDataTestId } from '@utils/dataTestIdFormatter';
import { printLog } from '@utils/utils';
import { get } from 'lodash';
import { Setter } from 'solid-js';

import { formSchema } from './validation';

type Fields = {
  billingHoldDescription: string;
  billingHoldReason: string;
};

type Props = {
  modalId: string;
  setPaymentStatus: Setter<string>;
  tabIndex: number;
  initialValues: Fields;
};

function HoldPayment(props: Props) {
  const { form, setFields, data, errors } = createForm<Fields>({
    initialValues: props.initialValues,
    extend: validator({ schema: formSchema }),
    onSubmit: () => {
      setPaymentHoldingReason();
    },
    onError: (errors) => {
      printLog(errors, 'errors');
    },
  });

  const setPaymentHoldingReason = () => {
    updateLoadPropertyAtIndex({
      billingHold: true,
      billingHoldReason: data().billingHoldReason,
      billingHoldDescription: data().billingHoldDescription,
    });
    props.setPaymentStatus('');
    closeModal(props.modalId);
  };

  return (
    <>
      <form ref={form} class="w-full">
        <div class="flex flex-col p-2 space-y-2">
          <SelectInput
            label="Reason *"
            menuItems={reasonsToHoldPayment}
            value={data().billingHoldReason}
            onChange={(value) => {
              setFields('billingHoldReason', value);
            }}
            error={get(errors(), 'billingHoldReason')?.[0] ?? null}
            dataTestId={formatDataTestId('Billing hold reason', 'selectInput')}
          />

          <TextField
            multiline={true}
            rows={5}
            value={data().billingHoldDescription}
            label={'Description *'}
            placeholder={'Enter Description here'}
            class="w-full"
            onChange={(value: string) => {
              setFields('billingHoldDescription', value);
            }}
            error={get(errors(), 'billingHoldDescription[0]')}
            dataTestId="description-textInput"
          />
        </div>
        <div class="flex justify-end mt-2">
          <Button
            label={'Save'}
            variant="contained"
            type="submit"
            dataTestId={formatDataTestId('Save', 'button')}
          />
          <Button
            label={'Cancel'}
            variant={'text'}
            onClick={() => {
              props.setPaymentStatus('');
              closeModal(props.modalId);
            }}
            dataTestId={formatDataTestId('Cancel', 'button')}
          />
        </div>
      </form>
    </>
  );
}

export default HoldPayment;
